import React, { useContext } from 'react';
import { PackagePickerSettingsParams } from '../components/PackagePicker/settingsParams';

const SettingsParamsContext = React.createContext<PackagePickerSettingsParams>({} as PackagePickerSettingsParams);

type SettingsParamsProviderProps = {
  settingsParams: PackagePickerSettingsParams;
  children: React.ReactNode;
};

export const SettingsParamsProvider: React.FC<SettingsParamsProviderProps> = ({ children, settingsParams }) => {
  return <SettingsParamsContext.Provider value={settingsParams}>{children}</SettingsParamsContext.Provider>;
};

export const useSettingsParams = () => useContext(SettingsParamsContext);
